import { z } from 'zod'

const jsonResponseSchema = z.object({}).passthrough()

export const billingAdminTransitionMigrationInventoryResponseSchema = jsonResponseSchema
export const billingAdminTransitionStripeEvidenceResponseSchema = jsonResponseSchema
export const billingAdminTransitionXanoReconciliationResponseSchema = jsonResponseSchema
export const billingAdminTransitionXanoSyncResponseSchema = jsonResponseSchema
export const billingAdminTransitionReadinessResponseSchema = jsonResponseSchema

export type BillingAdminTransitionMigrationInventoryResponse = z.infer<typeof billingAdminTransitionMigrationInventoryResponseSchema>
export type BillingAdminTransitionStripeEvidenceResponse = z.infer<typeof billingAdminTransitionStripeEvidenceResponseSchema>
export type BillingAdminTransitionXanoReconciliationResponse = z.infer<typeof billingAdminTransitionXanoReconciliationResponseSchema>
export type BillingAdminTransitionXanoSyncResponse = z.infer<typeof billingAdminTransitionXanoSyncResponseSchema>
export type BillingAdminTransitionReadinessResponse = z.infer<typeof billingAdminTransitionReadinessResponseSchema>
